var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_6630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4136 100.074L45.1822 101.985L44.9014 117.548L63.0105 110.933C56.7993 108.846 52.2635 105.175 50.4136 100.074Z",
    fill: "#FDBD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1511 83.6133L35 90.2441L45.182 101.985L50.4134 100.074C48.5689 94.9874 49.7064 89.2378 53.1511 83.6133Z",
    fill: "#F69833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6964 61.1551C60.5827 69.5988 45.6815 87.0224 50.4137 100.072L134.116 69.4944C129.384 56.4449 106.81 52.7113 83.6964 61.1551Z",
    fill: "#FECF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.832 108.413C123.946 99.9691 138.875 82.6228 134.115 69.4961L50.4131 100.074C55.1732 113.2 77.7187 116.857 100.832 108.413Z",
    fill: "#EE6723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.115 69.4961L50.4131 100.074C52.0521 104.593 58.3023 106.82 67.072 106.82C75.6217 106.82 86.5662 104.705 97.9763 100.537C121.09 92.0931 137.352 78.4222 134.115 69.4961Z",
    fill: "#F69833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.457 62.75C108.907 62.75 97.9624 64.8649 86.5522 69.0332C63.4386 77.4769 47.1765 91.1478 50.4135 100.074L134.116 69.4965C132.477 64.9767 126.226 62.75 117.457 62.75Z",
    fill: "#FDBD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.834 118.37H112.833C110.371 118.37 106.737 116.146 102.034 111.759C96.4707 106.568 90.0974 98.9662 84.0884 90.3527C78.0795 81.7397 73.142 73.1286 70.1854 66.1057C66.964 58.4524 66.5047 53.7467 68.8202 52.1191C69.3279 51.7626 69.9399 51.582 70.6391 51.582C72.5225 51.582 76.1924 52.9843 82.9787 59.6651L83.1271 59.8111L83.107 60.0188C83.0606 60.4987 83.0178 60.9829 82.9797 61.4582L82.9041 62.402L82.2383 61.7312C74.9264 54.3648 71.7077 53.5695 70.6631 53.5695C70.3652 53.5695 70.128 53.6301 69.9579 53.7496C68.9535 54.4554 68.8889 57.9118 72.012 65.3308C74.9159 72.2286 79.7816 80.7094 85.7128 89.211C91.6443 97.7133 97.9201 105.203 103.384 110.301C109.277 115.797 111.932 116.391 112.8 116.391C113.1 116.391 113.344 116.326 113.524 116.199C114.584 115.455 114.585 111.752 111.102 103.767L110.942 103.4L111.292 103.209C111.642 103.017 111.981 102.828 112.298 102.648L112.718 102.41L112.911 102.852C115.38 108.511 117.689 115.702 114.662 117.83C114.152 118.188 113.537 118.37 112.834 118.37ZM112.833 117.497H112.834L112.833 117.934L112.833 117.497Z",
    fill: "#EE6723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.394 108.175L101.359 108.609C100.774 115.84 99.2359 124.533 95.2242 124.885C95.1435 124.892 95.0598 124.895 94.9761 124.895C92.2509 124.895 89.6726 120.991 87.313 113.29C85.0805 106.004 83.348 96.2221 82.4349 85.7456C81.5216 75.2713 81.5353 65.3359 82.4734 57.7699C83.4959 49.5253 85.4425 45.2197 88.2588 44.9726C88.342 44.9649 88.4283 44.9609 88.5135 44.9609C90.4905 44.9609 93.47 47.1995 96.5203 57.6264L94.5286 58.0109C93.5102 54.5265 92.4003 51.6925 91.2985 49.7452C90.2793 47.944 89.2883 46.952 88.5079 46.952C88.4822 46.952 88.4564 46.9531 88.4309 46.9553C87.2102 47.0625 85.4325 50.0236 84.4413 58.0158C83.52 65.446 83.5089 75.2325 84.4101 85.5724C85.3118 95.9138 87.0159 105.55 89.2083 112.705C90.1902 115.909 91.2672 118.55 92.3229 120.342C93.2963 121.995 94.2384 122.905 94.9755 122.905C95.0009 122.905 95.0261 122.904 95.0513 122.902C96.2193 122.8 98.4204 119.718 99.3468 108.877L101.394 108.175Z",
    fill: "#EE6723"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_6630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinLogo);
export default __webpack_public_path__ + "static/media/zeppelinLogo.f2910029a0db729fe17d7014fda93171.svg";
export { ForwardRef as ReactComponent };